import Navbar from "./Components/Navbar.js";
import Intro from "./Components/introduction.js";
import About from "./Components/about.js";
import Work from "./Components/works.js";
import Experience from "./Components/Experience.js";
import Extrawork from "./Components/extra-works.js";
import Contact from "./Components/Contact.js"
function App() {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }
  return (
    <>
    <div className='back2'>
    <Navbar scrollToSection={scrollToSection}/>  
    <Intro/>
    <About/>
   <Experience/>
   <Work/>
   <Extrawork/>
   <Contact/>
    </div>
    </> 
  );
}

export default App;
